import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router';
import axios from 'axios';
import { makeItem } from '../item.js'; 
import { slugify } from '../utils/slugify';
import { trackEvent } from '../utils/trackEvents';
import { useSession } from '../Cart-Context/session'; 
import { getProductImage } from '../utils/imageHelper.js';
import '../App.css';
import { API_BASE_URL } from '../utils/apiConfig.js';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q'); 
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const { sessionId, experimentId } = useSession(); // Pull from hook

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/api/search?query=${query}`);
        
        const standardizedData = res.data.map(p => {
            const rawImage = p.productImage || p.image;
            const finalImage = (rawImage && rawImage !== "autoFill.jpg")
                ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${rawImage}`
                : `/imageComingSoon.jpg`;

            return makeItem(
                p.productId || p.id, 
                p.productName || p.name, 
                p.price, 
                finalImage, // Pass the full URL
                p.productDescription || p.description, 
                p.ingredients, 
                p.productWarnings || p.warnings, 
                p.calories, 
                p.totalFat, 
                p.monounsaturatedFat, 
                p.polyunsaturatedFat, 
                p.transFat, 
                p.totalCarbs, 
                p.totalSugars, 
                p.addedSugar, 
                p.cholesterol, 
                p.sodium, 
                p.fiber, 
                p.protein, 
                p.iron, 
                p.servingSize, 
                p.servingsPerContainer
            );
        });

        setProducts(standardizedData);

        // Record search results page view with experiment ID
        trackEvent(sessionId, 'SEARCH', 'Search Page View', { 
            searchTerm: query, 
            resultsCount: res.data.length 
        }, experimentId);

      } catch (err) {
        console.error("Error searching:", err);
      } finally {
        setLoading(false);
      }
    };

    if (query) {
      fetchSearchResults();
    }
  }, [query, sessionId, experimentId]); // Re-run this whenever the URL or IDs change

  return (
    <main className="page-container">
      <h1 className="page-title">Search Results for "{query}"</h1>

      {loading ? (
        <p style={{textAlign: 'center'}}>Searching...</p>
      ) : (
        <div className="products-grid">
          {products.length > 0 ? (
            products.map((product) => (
              <Link
                key={product.id}
                className="product-item"
                to={`/product/${product.id}/${slugify(product.name)}`}
                onClick={() => {
                    trackEvent(sessionId, 'CLICK', 'Search Result Item Click', { 
                        clickedProduct: product.name,
                        positionInList: products.indexOf(product) + 1
                    }, experimentId);
                }}
              >
                <img src={getProductImage(product.image)} alt={product.name} />
                
                <h3>{product.name}</h3>
                <div className="product-info-row">
                    <p>${product.price ? Number(product.price.toString().replace('$', '')).toFixed(2) : "0.00"}</p>
                    <p>{product.nutrition?.calories ?? 0} Cal</p>
                </div>
              </Link>
            ))
          ) : (
            <div style={{textAlign: 'center', width: '100%', gridColumn: '1 / -1'}}>
                <h3>No products found.</h3>
                <p>Try checking your spelling or using a broader term.</p>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default SearchResults;